import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest
} from "@angular/common/http";
import { DISABLED_NOTIFY_MESSAGE } from "@core/constants";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { catchError } from "rxjs/operators";
import { NotifyService } from "@core/services";

@Injectable({
  providedIn: "root"
})
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private notifyService: NotifyService) {}

  intercept<T>(
    request: HttpRequest<T>,
    next: HttpHandler
  ): Observable<HttpEvent<T>> {
    const disabledNotifyMessage = request.headers.get(DISABLED_NOTIFY_MESSAGE);

    if (disabledNotifyMessage) {
      return next.handle(request);
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        this.notifyService.showErrorMessage(err.error.message);
        throw err;
      })
    );
  }
}
